import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {WfInquiriesContainerModel} from "../../../../../models/aggregates/wf/inquiries";


@Injectable({
  providedIn: 'root'
})
export class EmailHandlerTrigger extends BaseApiTemplateService<WfInquiriesContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'wf/issue/email-handler-trigger';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'wf/issue/email-handler-trigger';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'wf/issue/email-handler-trigger';
    this.httpClient = http;
  }
}
